/**
 * Protected Gallery Layout
 * Ensures Flask authentication is active before rendering gallery content
 */

import React from 'react';
import useEnsureFlaskAuth from '../hooks/useEnsureFlaskAuth';
import LoadingSpinner from './LoadingSpinner';

interface ProtectedGalleryLayoutProps {
  children: React.ReactNode;
}

const ProtectedGalleryLayout: React.FC<ProtectedGalleryLayoutProps> = ({ children }) => {
  const { isAuthenticated, isLoading, error, retry } = useEnsureFlaskAuth();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-[#0a0a0a]">
        <LoadingSpinner />
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-[#0a0a0a]">
        <div className="bg-[#1a1a1a] border border-red-500 rounded-lg p-8 max-w-md text-center">
          <h2 className="text-red-500 font-bold mb-4">Authentication Error</h2>
          <p className="text-gray-400 mb-6">{error}</p>
          <button
            onClick={retry}
            className="bg-[#c9a84c] text-black px-6 py-2 rounded font-semibold hover:bg-[#b8941f] transition"
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-[#0a0a0a]">
        <div className="text-center">
          <p className="text-gray-400">Failed to authenticate. Please refresh the page.</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default ProtectedGalleryLayout;
